import { fetchData } from "@/utils/Config";

// 缓存工具函数
function getCachedData(key) {
  const cached = localStorage.getItem(key);
  if (cached) {
    const { data, expiry } = JSON.parse(cached);
    if (Date.now() < expiry) {
      return data; // 返回未过期的数据
    }
    localStorage.removeItem(key); // 删除过期数据
  }
  return null;
}

function setCachedData(key, data, ttl = 3600 * 1000) {
  // ttl 默认 1 小时（3600 秒）
  const expiry = Date.now() + ttl;
  localStorage.setItem(key, JSON.stringify({ data, expiry }));
}

export async function fetchInfoList() {
  const cacheKey = "infolist";
  const cachedData = getCachedData(cacheKey);
  if (cachedData) {
    return cachedData; // 返回缓存数据
  }
  const data = await fetchData("fyinfo", { domain: window.location.hostname });
  setCachedData(cacheKey, data); // 缓存数据
  return data;
}

export async function downapp() {
  const cacheKey = "downapp";
  const cachedData = getCachedData(cacheKey);
  if (cachedData) {
    return cachedData; // 返回缓存数据
  }
  const urlParams = new URLSearchParams(window.location.search);
  const downbm = urlParams.get("vv");
  const data = await fetchData("downapp", { downbm: downbm });
  setCachedData(cacheKey, data); // 缓存数据
  return data;
}